<script setup lang="ts">
import ProgressFrame from '@/modules/commissioning/views/layout/ProgressFrame.vue';
import ComErrorCtaButtons from '@/modules/commissioning/components/ComErrorCtaButtons.vue';
import { ERROR_CTA_BUTTONS } from '@/modules/commissioning/utils/error-constants';
import ComErrorIds from '@/modules/commissioning/components/ComErrorIds.vue';
</script>

<template>
  <ProgressFrame
    pageClass="fullfocus-page"
    titleTight
    withBackArrow
    backButtonClass="error-back-button"
  >
    <template #title><div class="error-title">SolShare Commission Failed</div></template>
    <template #subTitle>
      <div class="error-sub-title">Something wrong happened during the commissioning process.</div>
    </template>

    <div class="error-fail-ids--wrapper">
      <ComErrorIds :failIds="['Com Error #0']" unique />
    </div>

    <div class="error-intro">
      <p class="error-intro-text">Please contact Allume for support.</p>
      <!-- TODO: Display the contacts to the customer support team for the country -->
    </div>

    <ComErrorCtaButtons :ctaButtons="[ERROR_CTA_BUTTONS.CONTACT_SUPPORT]" />
  </ProgressFrame>
</template>

<style lang="less" scoped>
.error-intro-text {
  margin: 10px 0;
  text-align: center;
}
</style>
